import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'course-authoring.page.title': {
    id: 'course-authoring.page.title',
    defaultMessage: 'Course Authoring | {siteName}',
    description: 'Title tag',
  },
});

export default messages;
